/**
 * Stima della spesa pubblicitaria: spesa ≈ reach × frequenza × CPM / 1000.
 *
 * Il reach EU è un dato REALE (trasparenza DSA), quindi l'incertezza sta in:
 *  - CPM: benchmark Meta Italia per settore (forbice min-max, €/1000 impression)
 *  - frequenza media: 1,6 impression per persona (tipico campagne locali)
 *
 * È una STIMA da forbice, non un dato Meta: la UI la etichetta con "≈".
 * Tarare qui i CPM se hai benchmark migliori dai tuoi account reali.
 */

const FREQUENCY = 1.6;

/** CPM €/1000 per categoria Adlens: [min, max] */
const CPM_BY_CATEGORY: Record<string, [number, number]> = {
  'parrucchiere-beauty': [4, 8],
  estetica: [4, 8],
  ristorazione: [3, 6],
  fitness: [4, 8],
  immobiliare: [6, 12],
  retail: [3, 7],
  automotive: [5, 10],
  salute: [5, 10],
  formazione: [5, 11],
  turismo: [4, 9],
  'servizi-pro': [6, 12],
  altro: [3.5, 8],
};

const CPM_DEFAULT: [number, number] = [3.5, 8];

export interface SpendEstimate {
  min: number;
  max: number;
}

export function estimateSpend(
  euTotalReach: number | null,
  category: string | null,
): SpendEstimate | null {
  if (euTotalReach == null || euTotalReach <= 0) return null;
  const [cpmMin, cpmMax] = CPM_BY_CATEGORY[category ?? ''] ?? CPM_DEFAULT;
  const impressions = euTotalReach * FREQUENCY;
  return {
    min: (impressions * cpmMin) / 1000,
    max: (impressions * cpmMax) / 1000,
  };
}

const eur = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
});

/** "≈ 400–900 €" — sotto i 20€ la forbice non è significativa. */
export function formatSpend(estimate: SpendEstimate | null): string | null {
  if (!estimate || estimate.max < 20) return null;
  return `≈ ${eur.format(estimate.min)}–${eur.format(estimate.max)}`;
}
